<template>
  <div id="coordinatedAppointmentView">
    <div class="row pt-4 pb-2">
      <div class="col-12">
        <custom-separator :text="getTitle" />
      </div>
    </div>

    <row-appointment
      v-for="(item, index) in items"
      :key="`RowAppointment${index}`"
      :messages="messages"
      class="mb-3"
      :position="index"
      :options="item"
      @getCoordinations="getCoordinations"
    />

    <Pagination
      id="pgCoordinatedAppointment"
      :data="pagination"
      @pagination-go-page="
        pageNumber => $emit('pagination-go-page', pageNumber)
      "
    />
    <Error
      is-alert-mode
      message="La(s) cita(s) ha(n) sido coordinada(s) y aún está(n) pendiente por ser confirmada. Una vez el estatus de la cita sea confirmado, podrá seleccionarla como la Evaluación Inicial."
    />
  </div>
</template>

<script>
import { Error } from "@/components/common";
import Pagination from "@/components/common/Pagination.vue";
import RowAppointment from "@/components/student/quotes/RowAppointment";
import CustomSeparator from "@/components/common/CustomSeparator";

export default {
  name: "CoordinateAppointmentView",
  components: {
    Error,
    Pagination,
    RowAppointment,
    CustomSeparator
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    pagination: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    messages: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    dropdownItems() {
      return [
        {
          Title: "Historial de citas",
          Icon: "fa fa-list",
          IconColor: "text-green",
          Type: "Menu",
          EmitGo: "goEdit",
          Children: []
        }
      ];
    },
    getTitle() {
      return "Coordinación de Evaluación";
    }
  },
  methods: {
    getCoordinations() {
      this.$emit("getCoordinations", pageNumber);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name != "AppoinmentCoordination" &&
      this.$store.state.appointmentModule
    ) {
      this.$store.unregisterModule("appointmentModule");
    }
    next();
  }
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.divider-spacing {
  margin-left: 43px;
  margin-right: 54px;
}

.text-block {
  width: 25% !important;
}

.text-block > span {
  display: block;
}

.custom-accordion-item >>> .accordion-header {
  background: #fff;
}
.custom-accordion-item >>> .card-header {
  margin-bottom: 40px;
}
.custom-accordion-item
  >>> .card-header
  .accordion-header[aria-expanded="true"] {
  background: #fff;
}

.custom-accordion-item >>> .accordion-header.collapsed {
  background: #fff;
}

.custom-accordion-item >>> .collapse {
  background: #e7ebe9;
  margin-top: -2px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.appointment-main-title {
  font: Regular 16px/21px Lato;
  letter-spacing: 0;
  color: #3f5b60;
  opacity: 1;
  margin-left: 10px;
}

.appointment-main-body {
  margin-left: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.row-line {
  margin-top: -2px;
}

.appointment-table > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #fff !important;
}

.appointment-table > tbody > tr:nth-child(2n) > td,
.table-striped > tbody > tr:nth-child(2n) > th {
  background-color: #fff !important;
}

.badges {
  color: black;
  font-size: 14px;
  width: 60%;
  height: 41px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-coordinated {
  background: #f8ea80;
}
.badge-cancelled {
  background: #d5b89a;
}
.badge-confirmed {
  background: #a3e5b3;
}
.badge-denied {
  background: #ddb3d7;
}

#coordinatedAppointmentView >>> .customDropdown {
  float: right;
  position: relative;
  right: 30px;
}

#coordinatedAppointmentView >>> .customDropdown > li > a > i {
  margin-left: 12px;
  margin-top: 3px;
}
</style>
